import { useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  dataDoctorState,
  dataEducationState, //
  dataIdentityTypeState, //
  dataMaritalStatusState, //
  dataOccupationState, //
  dataReligionState,
  dataRoleState, //
  dataSpecialistState,
  fetchDataDoctor, //
  fetchDataEducation,
  fetchDataIdentityType,
  fetchDataMaritalStatus,
  fetchDataOccupation,
  fetchDataReligion,
  fetchDataRole,
  fetchDataSpecialist,
} from '../store'
import { useRecoilState } from 'recoil'
import { dataRoleListState, fetchDataRoleList } from '../store/role'

export default function useFetchDataGeneral(setLoading) {
  useFetchDataGeneral.propTypes = {
    setLoading: PropTypes.func,
  }
  const [dataDoctor, setDataDoctor] = useRecoilState(dataDoctorState)
  const [dataEducation, setDataEducation] = useRecoilState(dataEducationState)
  const [dataIdentityType, setDataIdentityType] = useRecoilState(dataIdentityTypeState)
  const [dataMaritalStatus, setDataMaritalStatus] = useRecoilState(dataMaritalStatusState)
  const [dataOccupation, setDataOccupation] = useRecoilState(dataOccupationState)
  const [dataReligion, setDataReligion] = useRecoilState(dataReligionState)
  const [dataRole, setDataRole] = useRecoilState(dataRoleState)
  const [dataRoleList, setDataRoleList] = useRecoilState(dataRoleListState)
  const [dataSpecialist, setDataSpecialist] = useRecoilState(dataSpecialistState)

  useEffect(() => {
    let isApiSubscribed = true

    async function getGeneralData() {
      setLoading(true)

      await fetchDataDoctor((doc) => {
        setDataDoctor(doc)
      })

      await fetchDataEducation((edu) => {
        setDataEducation(edu)
      })

      await fetchDataIdentityType((identity) => {
        setDataIdentityType(identity)
      })

      await fetchDataMaritalStatus((marital) => {
        setDataMaritalStatus(marital)
      })

      await fetchDataOccupation((occupation) => {
        setDataOccupation(occupation)
      })

      await fetchDataReligion((religion) => {
        setDataReligion(religion)
      })

      await fetchDataRole('', (role) => {
        setDataRole(role)
      })

      await fetchDataRoleList((role) => {
        setDataRoleList({ rows: role })
      })

      await fetchDataSpecialist((special) => {
        setDataSpecialist(special)
      })

      setLoading(false)
    }

    if (isApiSubscribed) {
      if (!dataEducation.length) {
        getGeneralData()
      }
    }

    return () => {
      // cancel the subscription
      isApiSubscribed = false
    }
  }, [
    dataEducation.length,
    setLoading,
    setDataDoctor,
    setDataEducation,
    setDataIdentityType,
    setDataMaritalStatus,
    setDataOccupation,
    setDataReligion,
    setDataRole,
    setDataRoleList,
    setDataSpecialist,
  ])

  return {
    dataDoctor,
    dataEducation,
    dataIdentityType,
    dataMaritalStatus,
    dataOccupation,
    dataReligion,
    dataRole,
    dataRoleList,
    dataSpecialist,
  }
}
